/** Signed uploads deliberately omit app credentials and only send the signed headers. */
export function putUpload(
  url: string,
  headers: Record<string, string>,
  body: Blob,
  onProgress: (percent: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url, true);
    xhr.timeout = 30 * 60 * 1000; // Matches the signed URL lifetime, including large ZIPs.
    for (const [key, value] of Object.entries(headers)) xhr.setRequestHeader(key, value);
    xhr.upload.onprogress = event => {
      if (event.lengthComputable) onProgress(Math.round(event.loaded / event.total * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(xhr.status === 403
        ? "The upload link expired or was refused. Select the file again to retry."
        : `The file could not be saved (${xhr.status}). Select it again to retry.`));
    };
    xhr.onerror = () => reject(new Error("The upload connection failed. Check your connection and select the file again to retry."));
    xhr.ontimeout = () => reject(new Error("The upload timed out. Select the file again to retry."));
    xhr.onabort = () => reject(new Error("The upload was interrupted. Select the file again to retry."));
    xhr.send(body);
  });
}
